import { Popover, PopoverItem } from "./v2";

// Player-card overflow menu — My Agency V2 restyle (CMP-POPOVER chrome; no
// dedicated players-menu artboard, so the shared menu family from the spec
// is used). WIRING UNCHANGED (Brief Rule 6): single "Change Agent" action →
// onChangeAgent(player); outside-click close now comes from the shared
// Popover (same idiom as the old inline listener).
const PlayerCardPopover = ({ isOpen, onClose, player, onChangeAgent }) => {
  if (!isOpen) return null;

  return (
    <Popover
      onClose={onClose}
      width={192}
      className="absolute right-4 top-[46px] z-50"
    >
      <PopoverItem
        onClick={() => {
          onChangeAgent(player);
          onClose();
        }}
      >
        Change Agent
      </PopoverItem>
    </Popover>
  );
};

export default PlayerCardPopover;
